import script from "./SelfCertificationDetailsFormModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelfCertificationDetailsFormModal.vue?vue&type=script&setup=true&lang=ts"

import "@/styles/modal/modal.css?vue&type=style&index=0&id=5e5d5550&scoped=true&lang=css"
import "./SelfCertificationDetailsFormModal.vue?vue&type=style&index=1&id=5e5d5550&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e5d5550"]])

export default __exports__